import { render, staticRenderFns } from "./OverlayChildProducts.vue?vue&type=template&id=45a75119&"
import script from "./OverlayChildProducts.vue?vue&type=script&lang=js&"
export * from "./OverlayChildProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a75119')) {
      api.createRecord('45a75119', component.options)
    } else {
      api.reload('45a75119', component.options)
    }
    module.hot.accept("./OverlayChildProducts.vue?vue&type=template&id=45a75119&", function () {
      api.rerender('45a75119', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayChildProducts.vue"
export default component.exports